import type { components } from '@bookingdei/api-client/types';
import { useLanguage } from '../../shell/language-context';
import { OfferPosterCard } from '../offers/offer-poster-card';
import { dealView, offerView, type OfferView, type ViewContext } from '../offers/offer-view';
import { useOfferFormat } from '../offers/use-offer-format';
import type { HomeFormat } from './use-home-format';

type OfferCardData = components['schemas']['OfferCard'];
type DealData = components['schemas']['DirectoryOfferCard'];

// "Today's offers" marquee cards: the shared 4:5 poster card (offers/offer-poster-card)
// for a bookable offer and for a deal a business announced itself (FR-A26 v3). Both
// open the offer popup; the home format supplies the category names (registry) and
// the offer format every figure. The marquee measures its first card through `.ofp`.
export function useRailViews(fmt: HomeFormat): ViewContext {
  const { t, lang } = useLanguage();
  const offerFmt = useOfferFormat();
  return { lang, fmt: offerFmt, t, catLabel: fmt.catLabel };
}

export function OfferRailCard({ offer, ctx, onOpen }: { offer: OfferCardData; ctx: ViewContext; onOpen: (v: OfferView) => void }) {
  return <OfferPosterCard view={offerView(offer, ctx)} onOpen={onOpen} className="ofp--rail" />;
}

export function DealRailCard({ deal, ctx, onOpen }: { deal: DealData; ctx: ViewContext; onOpen: (v: OfferView) => void }) {
  return <OfferPosterCard view={dealView(deal, ctx)} onOpen={onOpen} className="ofp--rail" />;
}
